// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    name: {
        title: '类型名称',
        type: 'input',
        value: '',
        rules: [{
            required: true,
            message: '请输入类型名称'
        }]
    },
    capacity: {
        title: '容量',
        type: 'input',
        value: '',
        rules: [{
            required: true,
            message: '请输入容量'
        }]
    },
    money: {
        title: '金额',
        type: 'input',
        aliasType: 'number',
        value: '',
        rules: [{
            required: true,
            message: '请输入容量'
        }]
    },
    withhold: {
        title: '月扣款金额',
        type: 'input',
        aliasType: 'number',
        value: '',
        rules: [{
            required: true,
            message: '请输入容量'
        }]
    },
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '姓名',
    dataIndex: 'name',
    key: 'name',
    ...columnPublicConfig
},
{
    title: '性别',
    dataIndex: 'sex',
    key: 'sex',
    ...columnPublicConfig,
},
{
    title: '年龄',
    dataIndex: 'age',
    key: 'age',
    ...columnPublicConfig,
},
{
    title: '地址',
    dataIndex: 'site',
    key: 'site',
    ...columnPublicConfig
},
{
    title: '身份证',
    dataIndex: 'sfz',
    key: 'sfz',
    ...columnPublicConfig
},
{
    title: '手机号码',
    dataIndex: 'mobile',
    key: 'mobile',
    ...columnPublicConfig
},
{
    title: '微信名',
    dataIndex: 'wx_name',
    key: 'wx_name',
    ...columnPublicConfig
},
    // {
    //     title: '操作',
    //     dataIndex: 'action',
    //     key: 'action',
    //     width: 160,
    //     scopedSlots: {
    //         customRender: 'c-action'
    //     }
    // }
]
